import React, { useMemo } from 'react';
import { centerGates } from '../../static/centers_dictionary';
import { FocusedBody } from './FocusedBody';

// чем ближе центры канала друг к другу, тем сильнее можно приблизить бодиграф
const channelZoom = {
  "34-57": 2,
  "26-44": 1.8,
  "37-40": 2.0,
  "21-45": 1.4,
  "20-57": 1,
  "47-64": 1.9,
  "9-52": 1.7,
  "24-61": 1.9,
  "35-36": 1,
  "28-38": 1.6,
  "6-59": 2,
  "11-56": 1.6,
  "32-54": 1.6,
  "1-8": 1.6,
  "12-22": 1,
  "4-63": 1.9,
  "23-43": 1.6,
  "30-41": 1.6,
  "13-33": 1.6,
  "10-34": 1.6,
  "19-49": 1.6,
  "2-14": 1.4,
  "29-46": 1.4,
  "42-53": 1.7,
  "20-34": 1,
  "27-50": 2,
  "10-20": 1.8,
  "5-15": 1.4,
  "7-31": 1.6,
  "3-60": 1.6,
  "17-62": 1.6,
  "25-51": 2.2,
  "39-55": 1.6,
  "18-58": 1.6,
  "16-48": 1,
  "10-57": 1.4,
}

const getChannelZoom = (gates) => {
  const [one, two] = gates.map(gate => parseInt(gate));
  return channelZoom[`${one}-${two}`] || channelZoom[`${two}-${one}`] || 1;
}

export default function ChannelFocused({
  style = {},
  design,
  highlightedGate = [],
  size = 'md',
  highlighted,
  numbers = true,
  width = '12em',
  height = '12em',
  zoom,
}) {

  const highlightedCenters = useMemo(() => {
    if (highlighted && highlighted.length) return highlighted;
    const gates = highlightedGate.map(one => parseInt(one));
    const centers = gates
      .map(gate => Object.keys(centerGates).find(center => centerGates[center].includes(gate)))
      .filter(Boolean);
    return [...new Set(centers)];
  }, [highlighted, highlightedGate]);

  return (
    <FocusedBody
      design={design}
      style={style}
      size={size}
      width={width}
      height={height}
      numbers={numbers}
      zoom={zoom || getChannelZoom(highlightedGate)}
      highlightedCenters={highlightedCenters}
      highlightedGate={highlightedGate}
    />
  )
}
